<script setup>

const store = useStore();


import { useStore } from "vuex";
import { activateDarkMode } from "@/assets/js/dark-mode";
//const sidebarType = computed(() => store.state.sidebarType);
const setSidebarType = (type) => store.commit("sidebarType", type);



    store.state.darkMode = true;
    setSidebarType("bg-default");
    activateDarkMode();
    document.querySelector("#sidenav-main").setAttribute("data-color", "danger");
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, made with
            <i class="fa fa-heart"></i> by
            <a
              href="https://rb7gaming.com/"
              class="font-weight-bold"
              target="_blank"
              >RB7 Gaming</a
            >
          </div>
        </div>
    
      </div>
    </div>
  </footer>
</template>
